/* eslint-disable */
import React from "react";
import {IconButton} from "@material-ui/core";
import styles from "./ShowFileIcon.module.css";
import CancelIcon from "@material-ui/icons/Cancel";
import {CheckFileType, ExtractFileName} from "../../../utils/ObjectUtils";
import PuiTypography from "../../../components/elements/PuiTypography";
import PuiTooltip from "../../../components/elements/PuiTooltip ";

interface ShowFileIconProps {
    // ファイル名
    fileName: string;
    // ファイルタイプ（拡張子を調べるため）
    fileType: string | undefined | null;
    // ファイルアイコンの下にファイル名を表示させるかどうか
    isVisibleFileName?: boolean;
    // ブラウザ表示ファイル名
    showfileName?: string;
    // 消去ボタンの表示設定
    isVisibleDeleteIcon?: boolean;
    // 消去イベント
    DeleteFile?: (documentIndex: number) => void;
    // ダウンロード・既存資料表示用のindex
    documentIndex?: number;
    // 資料ダウンロードイベント
    DownloadDocument? : (documentId: number) => void;
}

export default function ShowFileIcon({fileName, fileType, DeleteFile, DownloadDocument, ...props}: ShowFileIconProps) {

    const {isVisibleFileName= false, showfileName = ExtractFileName(fileName), isVisibleDeleteIcon = false, documentIndex = -1} = props;
    const checkedfileType = fileType ? CheckFileType(fileType, fileName.toLowerCase()) : "other";

    return (
        <div className={styles.root}>
            <img alt={checkedfileType} src={require(`../../../assets/image/icon_${checkedfileType}.png`)} className={styles.documentIcon} onClick={()=> DownloadDocument && DownloadDocument(documentIndex)} style={{cursor: DownloadDocument ? "pointer" : "auto"}}/>

            {isVisibleFileName &&
                <div className={styles.documentName} data-tip={showfileName} data-for='documentName' >
                    <PuiTypography size={14}>{showfileName}</PuiTypography>
                    <PuiTooltip id="documentName"/>
                </div>
           }

            {isVisibleDeleteIcon &&
                <div className={styles.deleteDocumentIcon}>
                    <IconButton onClick={() => DeleteFile && DeleteFile(documentIndex)}><CancelIcon style={{backgroundColor:"white",borderRadius:"50%"}}/></IconButton>
                </div>
           }
        </div>
    );
}
